/**
 *
 * LevelBar
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/* eslint-disable react/prefer-stateless-function */

const Container = styled.div`
  position: relative;
  width: 120px;
  height: 20px;
  background: #ebebeb;
  border: 1px solid white;
  @media screen and (max-width: 415px) {
    width: 100%;
    height: 15px;
  }
`;

const Level = styled.div`
  position: absolute;
  width: ${props => `${props.percentage}%`};
  height: 100%;
  background: #47b549;
`;

const Grid = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  background: repeating-linear-gradient(90deg, transparent, transparent 3px, white 3px, white 6px);
  @media screen and (max-width: 415px) {
    background: repeating-linear-gradient(90deg, transparent, transparent 4px, white 4px, white 8px);
  }
`;

const LevelBar = ({ percentage }) => (
  <Container>
    <Level percentage={percentage} />
    <Grid />
  </Container>
);

LevelBar.propTypes = {
  percentage: PropTypes.number
};

export default LevelBar;
